export class RoleFilter {
  name: string;
  pageNumber: number;
  pageSize: number;
}
